import React from 'react';
import { Row, Col } from 'antd';
import { Aside, Content } from './overview/style';
import Heading from '../../../components/heading/heading';

const AuthLayout = WraperContent => {
  return () => {
    return (
      <Row>
        <Col xxl={8} xl={9} lg={12} md={8} xs={24}>
          <Aside>
            <div className="auth-side-content">
              <Content style={{ padding:'0px' }}>

              <img
                  src="https://app.fastship.co/images/login_side_header.jpg"
                  style={{width:'100%'}}
                />
                
              <div style={{ zIndex:'999' ,  marginTop:'-30px' , position:'relative' }}>
                <img style={{ width: '400px'}} src={require('../../../static/img/Logo_white.png')} alt="" className="indent-left" />
                <Heading as="h2" className="white indent-left">
                  Franchise Application
                </Heading>
              </div>
              
              <img
                src="https://app.fastship.co/images/login_side_footer.jpg"
                style={{ width:'100%', marginTop:'-20px' , zIndex:'-1'  }}
              />



              </Content>
            </div>
          </Aside>
        </Col>

        <Col xxl={16} xl={15} lg={12} md={16} xs={24}>
          <WraperContent />
        </Col>
      </Row>
    );
  };
};

export default AuthLayout;
